import { useMutation } from '@apollo/client';
import { useCallback } from 'react';
import { updateAddressesCache } from '../useAddressesQuery';
import { DELETE_ADDRESS_MUTATION } from './deleteAddressMutation.rest';

export const useDeleteAddressMutation = () => {
  const [mutate, { loading, error }] = useMutation(DELETE_ADDRESS_MUTATION);

  const deleteAddress = useCallback(
    (id: string) =>
      mutate({
        variables: { id },
        update: (cache, result) => updateAddressesCache(cache, result, id)
      }),
    [mutate]
  );

  return [deleteAddress, { loading, error }] as const;
};
